export const INITIAL_STATE = {
  token: "",
  userName: "",
  isLoggedin: false,
  // Loading
  // Login
  isLoginLoading: false,
  loginError: "",
  // Login
  isRecoverPasswordLoading: false,
  recoverPasswordError: "",
  // Logout
  isLogoutLoading: false,
  logoutError: "",
};



// WEBPACK FOOTER //
// ./src/stores/Login/InitialState.js